export default "__VITE_ASSET__COM4rWod__"